export default [
  {
    id: 1,
    district: "Ananthapur",
    regionId: 1,
  },
  {
    id: 2,
    district: "Chittoor",
    regionId: 1,
  },
  {
    id: 3,
    district: "Madanapalle",
    regionId: 1,
  },
  {
    id: 4,
    district: "Kadapa",
    regionId: 1,
  },
  {
    id: 5,
    district: "Hindupur",
    regionId: 1,
  },
  {
    id: 6,
    district: "Dharmavaram",
    regionId: 1,
  },
  {
    id: 7,
    district: "Karimganj",
    regionId: 2,
  },
  {
    id: 8,
    district: "Hailakandi",
    regionId: 2,
  },
  {
    id: 9,
    district: "Cachar",
    regionId: 2,
  },
  {
    id: 10,
    district: "Dima Hasso - North Cachar Hill",
    regionId: 2,
  },
  {
    id: 11,
    district: "Karbi Anglong",
    regionId: 2,
  },
  {
    id: 12,
    district: "Udalguri",
    regionId: 2,
  },
  {
    id: 13,
    district: "Gaya",
    regionId: 3,
  },
  {
    id: 14,
    district: "Aurangabad",
    regionId: 3,
  },
  {
    id: 15,
    district: "Arwal",
    regionId: 3,
  },
  {
    id: 16,
    district: "Auranagabad",
    regionId: 3,
  },
  {
    id: 17,
    district: "Bhojpur",
    regionId: 3,
  },
  {
    id: 18,
    district: "Buxar",
    regionId: 3,
  },
  {
    id: 19,
    district: "Hyderabad",
    regionId: 4,
  },
  {
    id: 20,
    district: "Rangareddy",
    regionId: 4,
  },
  {
    id: 22,
    district: "Siddipet",
    regionId: 4,
  },
  {
    id: 23,
    district: "Medak",
    regionId: 4,
  },
  {
    id: 24,
    district: "Karim Nagar",
    regionId: 4,
  },
  {
    id: 25,
    district: "Mancherial",
    regionId: 4,
  },
  {
    id: 26,
    district: "Surat",
    regionId: 5,
  },
  {
    id: 27,
    district: "Vadodara",
    regionId: 5,
  },
]
